// Module
var code = "<gli-body gli-default-img=\"{{ blib.defaultBikeImage }}\" gli-img=\"{{ bike.image.thumbnail }}\">\n    <img data-ng-if=\"bike.totalCondition > 0\" data-ng-src=\"{{ blib.getCertificationImageUrl(bike) }}\"\n         class=\"img-certification\"/>\n</gli-body>";
// Exports
var _module_exports = code;;
var path = 'components/bike/list/base/bl-item-body.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;